import { AspectRatio, Box, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { t } from "i18next";
import { WelcomeGiftType } from "../types";

export function BundleCard({
  gift,
  isSelected,
  onSelect,
}: {
  gift: WelcomeGiftType;
  isSelected: boolean;
  onSelect: () => void;
}) {
  return (
    <Box
      as="button"
      gc-testing-id={`btnBundle-${gift.id}`}
      onClick={onSelect}
      width="100%"
      position="relative"
      isolation="isolate"
      cursor="pointer"
      borderRadius="24px"
      background={isSelected ? "transparent.black.50" : "transparent.black.30"}
      boxShadow="0 4px 12px 0 rgba(0,0,0,0.35)"
      p={6}
      transition="background 0.2s ease-in-out"
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        zIndex: -1,
        borderRadius: "inherit",
        padding: isSelected ? "2px" : "1px",
        background: isSelected
          ? "linear-gradient(45deg, #FF5A2C 0%, #FF5A2C66 50%, #FF5A2C 100%)"
          : "linear-gradient(45deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.3) 100%)",
        WebkitMask:
          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
        transition: "padding 0.2s ease-in-out, background 0.2s ease-in-out",
      }}
    >
      <VStack gap={4} width="100%" alignItems="stretch">
        {gift.image_url && (
          <AspectRatio
            ratio={310 / 175}
            width="100%"
            borderRadius="8px"
            overflow="hidden"
          >
            <Image
              src={gift.image_url}
              alt={gift.display_name}
              objectFit="cover"
            />
          </AspectRatio>
        )}
        <HStack gap={4} width="100%" alignItems="flex-end">
          <VStack flex={1} minW={0} gap={2} alignItems="flex-start">
            <Text
              fontSize="18px"
              fontWeight={600}
              lineHeight="1"
              letterSpacing="-0.5px"
              color="white"
              textAlign="left"
              noOfLines={2}
            >
              {gift.display_name}
            </Text>
            <HStack gap={2} alignItems="center">
              <Box
                bg="success.800"
                pl="8px"
                pr="12px"
                py="4px"
                borderLeftRadius="8px"
                borderRightRadius="100px"
              >
                <Text
                  fontSize="14px"
                  lineHeight="1.3"
                  color="success.200"
                  whiteSpace="nowrap"
                >
                  {t("components.payments.bundleSelection.valueLabel", { value: gift.total_value_string })}
                </Text>
              </Box>
              <HStack fontSize="14px" lineHeight="1.3" color="neutral.500" gap={1} whiteSpace="nowrap">
                <Text>{t("components.payments.bundleSelection.bookCount", { count: gift.total_books })}</Text>
                <Text>&bull;</Text>
                <Text>{t("components.payments.bundleSelection.pageCount", { count: gift.total_pages })}</Text>
              </HStack>
            </HStack>
          </VStack>
          <Box
            boxSize="32px"
            borderRadius="full"
            flexShrink={0}
            borderWidth="2px"
            borderStyle="solid"
            borderColor={isSelected ? "blaze.blaze" : "transparent.white.40"}
            background={isSelected ? "blaze.blaze" : "transparent"}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {isSelected && (
              <Box
                as="svg"
                viewBox="0 0 24 24"
                width="18px"
                height="18px"
                fill="none"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </Box>
            )}
          </Box>
        </HStack>
      </VStack>
    </Box>
  );
}
